import { TBusinessAccountDetails } from './types'

export const formatBusinessAddress = ({
  address_line_1,
  address_line_2,
  city,
  state_or_province,
  postal_code
}: TBusinessAccountDetails['address']) => {
  const streetLine = [address_line_1, address_line_2].filter(Boolean).join(', ')
  const cityStatePostalCodeLine = [
    city,
    [state_or_province, postal_code].filter(Boolean).join(' ')
  ]
    .filter(Boolean)
    .join(', ')

  return [streetLine, cityStatePostalCodeLine].filter(Boolean)
}
